export default "__VITE_PUBLIC_ASSET__1c1a3994__"